export default __webpack_public_path__ + "static/media/Heaven's Kal Gum.cf62cd75.jpg";